import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';

import { sortBy } from 'lodash';

import TextField from '@material-ui/core/TextField';
import AutoComplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';

import * as K2ACoreActions from '../actions/k2aCoreActions';

import * as classes from './BobClientSelector.module.css';

const BobSiteSelector = ({
    fetchSites,
    clientId,
    companyId,
    value,
    errors,
    handleChange,
    touched,
    label,
    required,
    disabled,
    isFromRuleDebugger,
    ...props
}) => {
    const [filteredSitesList, setFilteredSitesList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [siteValue, setSiteValue] = useState({});

    useEffect(() => {
        const init = async () => {
            setLoading(true);
            const list = await fetchSites(clientId.id, { limit: 1000 });
            setFilteredSitesList(list);
            setLoading(false);
        };

        if (companyId && clientId && clientId.id && !isFromRuleDebugger) init();
    }, [companyId, clientId]);

    useEffect(() => {
        const init = async () => {
            setLoading(true);
            const list = await fetchSites(clientId.id, { limit: 1000 });
            setFilteredSitesList(list);
            setLoading(false);
        };

        if (clientId && clientId.id && isFromRuleDebugger) init();
    }, [clientId]);

    useEffect(() => {
        setSiteValue(value);
    }, [value]);

    return (
        <AutoComplete
            id="siteId"
            name="siteId"
            options={sortBy(filteredSitesList, 'name')}
            getOptionLabel={(option) => option.name || ''}
            value={siteValue}
            getOptionSelected={(option, value) => option.name === value.name}
            onChange={(event, value) => handleChange(event, value)}
            size="small"
            disabled={disabled}
            required
            renderInput={(params) =>
                <TextField
                    {...params}
                    className={classes.Required}
                    label={label}
                    variant="outlined"
                    required={required}
                    error={errors ? true : false}
                    helperText={errors ? errors : null}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <CircularProgress color="inherit" size={15} /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                />}
        />
    );
};

const mapDispatchToProps = {
    ...K2ACoreActions
};

export default connect(null, mapDispatchToProps)(BobSiteSelector);
